import axios from 'axios';

// initial state
const state = {
    isLoading: false,
    products: [],
    campaigns: [],
}

// getters
const getters = {
    //
}

// actions
const actions = {
    getProducts({ commit, state }) {
        state.isLoading = true;
        
        return axios
            .get(API_URL + '/novo-pedido/carrinho')
            .then(response => {
                state.isLoading = false;

                commit('setProducts', response.data.produtos);

                if (response.data.campaigns) {
                    commit('setCampaigns', response.data.campaigns);
                }

                return response.data.produtos;
            });
    },
    incrementProduct: function({ commit, state, dispatch }, produto) {
        produto.quantidade = parseInt(produto.quantidade) + parseInt(produto.embalagem);

        return dispatch('updateProduct', produto);
    },
    checkQuantityProduct: function({ commit, state, dispatch }, produto) {
        produto.quantidade = parseInt(produto.embalagem ? Math.ceil(produto.quantidade / produto.embalagem) * produto.embalagem : produto.quantidade);


        return dispatch('updateProduct', produto);
    },
    decrementProduct: function({ commit, state, dispatch }, produto) {
        produto.quantidade = Math.max(parseInt(produto.embalagem), parseInt(produto.quantidade) - parseInt(produto.embalagem));

        return dispatch('updateProduct', produto);
    },
    addProduct: function({ commit, state, dispatch }, produto) {
        var vm = this;

        return new Promise((resolve, reject) => {
            if (produto.quantidade <= 0) {
                reject('Quantidade inválida');
            } else {

                axios
                    .post(API_URL + '/novo-pedido/carrinho/adicionar', {
                        id: produto.produto_id,
                        qtd: produto.quantidade
                    })
                    .then(response => {
                        if (response.data.error) {
                            reject(response.data.error);
                        } else {
                            dispatch('getProducts')
                                .then(result => resolve(result))
                                .catch(error => reject(error));
                        }
                });
            }
        });
        
    },
    updateProduct: function({ commit, state, dispatch }, produto) {
        var vm = this;

        state.isLoading = true;

        return new Promise((resolve, reject) => {
            if (produto.quantidade <= 0) {
                state.isLoading = false;

                reject('Quantidade inválida');
            } else {

                axios
                    .post(API_URL + '/novo-pedido/carrinho/atualizar', {
                        id: produto.produto_id,
                        qtd: produto.quantidade
                    })
                    .then(response => {
                        state.isLoading = false;

                        if (response.data.error) {
                            reject(response.data.error);
                        } else {
                            dispatch('getProducts')
                                .then(result => resolve(result))
                                .catch(error => reject(error));
                        }
                });
            }
        });
    },
    removeProduct: function({ commit, state, dispatch }, produto) {
        var vm = this;

        state.isLoading = true;

        return new Promise((resolve, reject) => {
            axios
                .post(API_URL + '/novo-pedido/carrinho/remover', {
                    id: produto.produto_id
                })
                .then(response => {
                    state.isLoading = false;
                    
                    if (response.data.error) {
                        reject(response.data.error);
                    } else {
                        dispatch('getProducts')
                            .then(result => resolve(result))
                            .catch(error => reject(error));
                    }
                });
            });
    }
}

// mutations
const mutations = {
    setProducts (state, products) {
        state.products = products;
    },

    setCampaigns (state, campaigns) {
        state.campaigns = campaigns;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}